import React from 'react';
import { Chip, Tooltip, Box } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import AccountTreeIcon from '@mui/icons-material/AccountTree';

const CorrelationBadge = ({ isCorrelated, hasCorrelations, size = 'small', showLabel = false }) => {
  if (!isCorrelated && !hasCorrelations) {
    return null;
  }

  const chipSx = {
    '& .MuiChip-icon': {
      fontSize: size === 'small' ? '0.875rem' : '1rem',
    },
    height: size === 'small' ? 20 : 24,
    '& .MuiChip-label': {
      px: showLabel ? 1 : 0,
    },
  };

  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      {hasCorrelations && (
        <Tooltip title="Tem despesas vinculadas (clique para expandir)">
          <Chip
            icon={<AccountTreeIcon />}
            label={showLabel ? 'Tem vinculos' : undefined}
            size={size}
            color="success"
            variant="outlined"
            sx={chipSx}
          />
        </Tooltip>
      )}
      {isCorrelated && (
        <Tooltip title="Despesa correlacionada (ja incluida em outra despesa)">
          <Chip
            icon={<LinkIcon />}
            label={showLabel ? 'Correlacionada' : undefined}
            size={size}
            color="info"
            variant="outlined"
            sx={chipSx}
          />
        </Tooltip>
      )}
    </Box>
  );
};

export default CorrelationBadge;
